<template>
    <div>
      <el-card class="box-card" style="margin: 40px;">
        <div slot="header" class="clearfix">
          <span>广告管理</span>
          <el-button style="float: right;" @click="updateqx" type="success" icon="el-icon-edit" >更新</el-button>
          <el-button style="float: right; margin-right: 10px;" @click="queryuser" type="success" icon="el-icon-edit" >查看</el-button>
        </div>
        <div class="text item">
          <div class="source">
            <el-row class="querypanel">
              <el-table
                stripe
                :data="ggdata"
                ref="multipleTable">
                <el-table-column
                  prop="APP_ID"
                  width="120px"
                  label="广告标识">
                </el-table-column>
                <el-table-column
                  prop="APP_NAME"
                  width="200px;"
                  label="广告名称">
                </el-table-column>
                <el-table-column
                  prop="BUSS_ID"
                  width="200px;"
                  label="BUSSID">
                </el-table-column>
                <el-table-column
                  prop="BUSS_NAME"
                  width="200px;"
                  label="BUSSNAME">
                </el-table-column>
                <el-table-column
                  prop="CLICK_URL"
                  label="上游链接">
                </el-table-column>
              </el-table>
            </el-row>
          </div>
        </div>
      </el-card>

    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'QueryGG',
    data () {
      return {
        ggdata: []
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.querygg()
    },
    methods: {
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.ggdata = res.data
            } else {
              that.ggdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>
  .gtopicon {
    font-size: 14px;
    padding-left: 15px;
  }
  .treerow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .treerowinput {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
    width:200px;
  }
  .treeop {
    flex: 1;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-end;
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/gg/QueryGG.vue